'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notice = function Notice(_ref) {
  var icon = _ref.icon,
      header = _ref.header,
      content = _ref.content,
      _ref$level = _ref.level,
      level = _ref$level === undefined ? 'warning' : _ref$level;
  return _react2.default.createElement(
    'div',
    { className: 'notice level-' + level },
    icon && _react2.default.createElement(
      'div',
      { className: 'notice-icon' },
      icon
    ),
    _react2.default.createElement(
      'div',
      { className: 'notice-content' },
      header && _react2.default.createElement(
        'div',
        { className: 'notice-content-header' },
        header
      ),
      content && _react2.default.createElement(
        'div',
        { className: 'notice-content-text' },
        content
      )
    )
  );
};

exports.default = Notice;